export const PublicationTypes = {
    Design: "Design",
    Production: "Production",
    Installation: "Installation",
    All: "All"
};